// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"40e2f031","703":"d03bbfea"}[chunkId] + ".chunk.js";
};